window.addEventListener("load", () => {
  document.forms[0].submit();
});
